import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";
import { selectSelectedWells, useMapStore } from "stores/map";

import { Uwi } from "models";

import { SelectedWellT } from "components/well-list/context/WellListContext";

/**
 * @param uwiOverride pins the result to one well and ignores both stores. The
 * well card panel needs a card that holds its well while the map selection
 * moves on. Callers that pass nothing keep the map-selection behaviour.
 */
const useSelectedWellFromStore = (uwiOverride?: Maybe<string>): Maybe<SelectedWellT> => {
  const zustandSelectedWells = useMapStore(selectSelectedWells);
  const reduxSelectedWells = useSelector((state: RootState) => state.map.selectedWells);

  if (uwiOverride) {
    return { Uwi: uwiOverride, FormattedUwi: new Uwi().toFormatted(uwiOverride) };
  }

  // Zustand is the primary store (parent tab — written directly on well click).
  // Fall back to Redux when Zustand is empty: in a popped-out tab without a map,
  // redux-state-sync delivers well-selection actions from the parent tab into
  // Redux, so we read from there until the Zustand relay catches up.
  const selectedWells =
    Object.keys(zustandSelectedWells).length > 0
      ? zustandSelectedWells
      : reduxSelectedWells;

  if (selectedWells) {
    const selectedWell: SelectedWellT =
      Object.keys(selectedWells).length > 0
        ? { ...(Object.values(selectedWells)[0] as SelectedWellT) }
        : null;

    if (selectedWell?.Uwi && !selectedWell?.FormattedUwi) {
      selectedWell.FormattedUwi = new Uwi().toFormatted(selectedWell?.Uwi);
    }

    return selectedWell;
  }
  return null;
};

export default useSelectedWellFromStore;
